export default __webpack_public_path__ + "static/media/b1.85327991.png";